import { Box, Typography } from '@wishket/design-system';
import dayjs, { Dayjs } from 'dayjs';
import { twJoin } from 'tailwind-merge';

type PossibleGap = 4 | 5;

const MARGINS: Record<PossibleGap, string> = {
  4: 'ml-4',
  5: 'ml-7',
};

interface GrassRowHeaderProps {
  startDate: Dayjs;
}

const GrassRowHeader = ({ startDate }: GrassRowHeaderProps) => {
  const startDay = startDate.day();

  const monthStartDaysGap = Array.from({ length: 12 }, (_, i) => {
    const date = dayjs(startDate).month(i).startOf('month');
    return Math.floor((date.diff(startDate, 'day') + startDay) / 7);
  }).map(
    (days, index, arr) =>
      (index === 0 ? days : days - arr[index - 1]) as PossibleGap
  );

  return (
    <Box className="flex h-6 pl-6">
      {Array.from({ length: 12 }, (_, index) => (
        <Typography
          key={index}
          variant="body2"
          className={twJoin(
            'w-8 text-w-gray-600',
            MARGINS[monthStartDaysGap[index]]
          )}
        >
          {`${index + 1}월`}
        </Typography>
      ))}
    </Box>
  );
};

export default GrassRowHeader;
